import * as React from "react"
import { Box, Skeleton } from "@mui/material"
import { AmchartSeeker } from "@ui-seeker/core"

import { useSkuDetailsPricingEvolutionData } from "./@hooks"
import SkuDetailsPricingEvolutionActions from "./Actions"


export default function SkuDetailsPricingEvolution() {

	const { dataEvolutionKeys, isLoadingDataEvolution, currency, resetEvolutionData, handleChangeEvolutionSelect, 
		evolutionDatePeriod, selectOptions, dataEvolutionFiltered, selectValue
	} = useSkuDetailsPricingEvolutionData()

	if (isLoadingDataEvolution) return <Skeleton variant="rectangular" height={500} />
	if (!dataEvolutionFiltered?.length || isLoadingDataEvolution) return <></>


	return <AmchartSeeker
		rootID='price-stock-evolution'
		data={dataEvolutionFiltered}
		title='Pricing Market Evolution'
		series={[...(dataEvolutionKeys.map(key => ({
			name: key,
			yField: key,
			xField: "date",
			type: "line",
			connect: true,
			tooltip: {
				tooltipVisibleOnZero: true,
				useSingleTooltip: true,
				customSort: (a, b) => b.value - a.value
			}
		}))),
		]}
		chartProps={{
			numberFormat: `#,###.00 ' ${currency}'`,
			dateFormatReceived: 'yyyyMMdd',
			xAxis: {
				categoryField: 'date',
				isDateAxis: true,
				dateFormat: 'dd MMM yyyy',
				baseInterval: {
					timeUnit: 'day',
					count: 1
				}
			}
		}}
		cardProps={{ 
			actions: 
			<SkuDetailsPricingEvolutionActions
				options={selectOptions}
				value={selectValue}
				evolutionDatePeriod={evolutionDatePeriod}
				onChange={handleChangeEvolutionSelect}
				handleClick={resetEvolutionData} 
			/> 
		}}
	/>
}